import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ConfigService} from '../service/config.service';
import {Keys, StorageService} from '../service/storage.service';
import {LenderDetailsService} from '../service/lender-details.service';
import {LoanDetailsService} from '../service/loan-details.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';

@Component({
    templateUrl: './lender-bank-details.component.html',
    styleUrls: ['./lender-bank-details.component.css'],
    providers: [LenderDetailsService, LoanDetailsService]
})
export class LenderBankDetailsComponent implements OnInit {
    public finzyDomain: boolean;
    public otherDomain: boolean;
    public preFilledBankDetails: any;

    private readonly router: Router;
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;
    private readonly storageService: StorageService;
    private readonly loanDetailsService: LoanDetailsService;
    private readonly lenderDetailsService: LenderDetailsService;

    constructor(router: Router, httpClient: HttpClient, configService: ConfigService, storageService: StorageService,
                lenderDetailsService: LenderDetailsService, loanDetailsService: LoanDetailsService, public analyticsTracker: AnalyticsTracker) {
        this.router = router;
        this.httpClient = httpClient;
        this.configService = configService;
        this.storageService = storageService;
        this.loanDetailsService = loanDetailsService;
        this.lenderDetailsService = lenderDetailsService;
    }

    async ngOnInit(): Promise<void> {
        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const lenderInfoResponse = await this.lenderDetailsService.getLenderDetails(lenderId);
        const lenderDetails = lenderInfoResponse.lender_info;
        if (lenderDetails.bank_account) {
            this.preFilledBankDetails = lenderDetails.bank_account;
        } else if (lenderDetails.profile.loan_details.length > 0) {
            const loanId = lenderDetails.profile.loan_details[0].loan_id;
            const loanInfoResponse = await this.loanDetailsService.getLoanDetails(loanId);
            this.preFilledBankDetails = loanInfoResponse.loan_info.bank_account;
        }

    }

    public onSubmit(bankFormData: any): void {
        const requestBody: any = bankFormData;
        requestBody.lender_id = this.storageService.getItem(Keys.LENDER_ID);
        requestBody.userId = this.storageService.getItem(Keys.PROFILE_ID);

        this.httpClient.post(this.configService.baseUrl() + 'addBankDetailsLender', requestBody)
            .subscribe((result: any) => {
                if (result.status === 'success') {
                    this.storageService.saveItem(Keys.LENDER_BANK_INFO, 'true');
                    this.router.navigate(['/invest/lender-nominee']);
                }
            });
    }
}
